import { useCallback } from 'react';

const DAYS_IN_MONTH = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

const isLeapYear = (year: number): boolean => {
	return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
};

export const useDateValidation = () => {
	const isValidDateString = useCallback((dateStr: string): boolean => {
		if (!dateStr || dateStr.trim() === '') return false;

		const match = dateStr.match(
			/^(\d{2})\.(\d{2})\.(\d{4})\s+(\d{1,2}):(\d{2})$/,
		);
		if (!match) return false;

		const [, day, month, year, hour, minute] = match;
		const dayNum = parseInt(day, 10);
		const monthNum = parseInt(month, 10);
		const yearNum = parseInt(year, 10);
		const hourNum = parseInt(hour, 10);
		const minuteNum = parseInt(minute, 10);

		if (monthNum < 1 || monthNum > 12) return false;
		if (dayNum < 1 || dayNum > 31) return false;
		if (hourNum < 0 || hourNum > 23) return false;
		if (minuteNum < 0 || minuteNum > 59) return false;

		if (dayNum > DAYS_IN_MONTH[monthNum - 1]) return false;

		if (monthNum === 2 && dayNum === 29 && !isLeapYear(yearNum)) return false;

		const parsed = new Date(yearNum, monthNum - 1, dayNum, hourNum, minuteNum);
		return !isNaN(parsed.getTime());
	}, []);

	const parseDateString = useCallback(
		(dateStr: string): number | null => {
			if (!isValidDateString(dateStr)) return null;

			const match = dateStr.match(
				/^(\d{2})\.(\d{2})\.(\d{4})\s+(\d{1,2}):(\d{2})$/,
			);
			if (!match) return null;

			const [, day, month, year, hour, minute] = match;
			const parsed = new Date(
				parseInt(year),
				parseInt(month) - 1,
				parseInt(day),
				parseInt(hour),
				parseInt(minute),
			);

			return isNaN(parsed.getTime()) ? null : parsed.getTime();
		},
		[isValidDateString],
	);

	return {
		isValidDateString,
		parseDateString,
	};
};
